import React from "react";
import MfaChallengeForm from "./MfaChallengeForm";
import AuthLayout from "../components/AuthLayout";

const MfaChallenge: React.FC = () => {
  return (
    <AuthLayout
      title="Two-factor authentication"
      subtitle="Enter the code from your authenticator app to continue"
    >
      <MfaChallengeForm />
    </AuthLayout>
  );
};

export default MfaChallenge;
